module.exports = __webpack_public_path__ + "static/sergek-25f8bbc9d2824b5d9f10b490d76d12c0.png";